import { Component, OnInit, ViewChild } from "@angular/core";
import { OwlOptions } from "ngx-owl-carousel-o";
import { ActivatedRoute, Router } from "@angular/router";
import { AppService } from "../app.service";
import * as welcomeData from "../../assets/welcome.json";

@Component({
  selector: "app-landing",
  templateUrl: "./landing.component.html",
  styleUrls: ["./landing.component.css"],
})
export class LandingComponent implements OnInit {
  isDragging: boolean;
  testimonialsLoader = false;
  landingData: any = (welcomeData as any).default;
  faqContent: any = [];
  testimonials: any = [];
  panelOpenState = false;
  array = [];
  step: any;
  step1: any;
  constructor(
    private route: Router,
    private router: ActivatedRoute,
    private service: AppService
  ) { }

  @ViewChild("home", { static: false }) home;
  @ViewChild("aboutus", { static: false }) aboutus;
  @ViewChild("series", { static: false }) series;
  @ViewChild("plan", { static: false }) plan;

  ngOnInit(): void {
    setTimeout(() => {
      this.router.queryParams.subscribe((params) => {
        if (params["data"]) {
          this.navigateTo(params["data"]);
        } else {
          window.scrollTo(0, 0);
        }
      });
    }, 500);
    this.getFAQ();
    this.getTestimonials();
  }

  /**
   * Use for scroll view
   * @param element 
   */
  navigateTo(element: string): void {
    if (element) {
      this[element].nativeElement.scrollIntoView({ behavior: "smooth" });
    }
  }

  generCarousel: OwlOptions = {
    loop: false,
    autoplay: false,
    mouseDrag: true,
    autoWidth: true,
    autoHeight: true,
    touchDrag: true,
    pullDrag: true,
    dots: false,
    navSpeed: 700,
    smartSpeed: 1,
    skip_validateItems: true,
    navText: ["", ""],
    responsive: {
      0: {
        items: 1.1,
      },
      375: {
        items: 1.1,
      },
      425: {
        items: 2.1,
      },
      575: {
        items: 2.1,
      },
      786: {
        items: 3,
      },
      991: {
        items: 3,
      },
      1366: {
        items: 3,
      },
      1500: {
        items: 3,
      },
    },
    nav: true,
  };
  /**
   * This function is use for faq
   * @param index 
   */
  setStep(index: number) {
    this.step = index;
    this.panelOpenState = false;
  }
  setStep1(index: number) {
    this.step1 = index;
    this.panelOpenState = true;
  }
  /**
   * Return faq content
   */
  getFAQ() {
    this.service.faq().subscribe(
      (data: any) => {
        if (data) {
          // this.spinner.hide();
          this.faqContent = data.results;

          for (let i = 0; i < this.faqContent.length; i++) {
            if (i % 2 === 0) {
              this.array.push({ zeroIndex: this.faqContent[i] });
            } else {
              const j = this.array.length - 1;
              this.array[j].firstIndex = this.faqContent[i];
            }
          }
        }
      }
    );
  }
  /**
   * Return testimonials content
   */
  getTestimonials() {
    this.service.testimonials().subscribe(
      (data: any) => {
        if (data) {
          this.testimonialsLoader = true;
          this.testimonials = data.results;
          if (data.results.length <= 3) {
            this.generCarousel.mouseDrag = false;
          }
        }
      },
      (err) => {
        if (err) { this.testimonialsLoader = false; }

      }
    );
  }
}
